// Auto-detect API URL based on current domain
const getApiUrl = () => {
  const hostname = window.location.hostname;
  
  // Production domain
  if (hostname === 'lettersofunspokenhearts.com' || hostname === 'www.lettersofunspokenhearts.com') {
    return 'https://lettersofunspokenhearts.com/api';
  }
  
  // Preview/development - use environment variable
  if (process.env.REACT_APP_BACKEND_URL) {
    return `${process.env.REACT_APP_BACKEND_URL}/api`;
  }
  
  // Fallback to same origin
  return `${window.location.origin}/api`;
};

export const API = getApiUrl();
